module.exports = __webpack_public_path__ + "static/media/logo.fff7402a.png";